<template>
  <div class="icon-on-hover" :class="{ 'icon-on-hover--disabled': isDisabled }">
    <slot />
    <div class="icon-on-hover__hover">
      <EditIcon16 />
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import EditIcon16 from '@components/Icons/EditIcon16.vue';

export default defineComponent({
  name: 'IconOnHover',

  components: {
    EditIcon16,
  },

  props: {
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
});
</script>

<style lang="scss" scoped>
@use 'settings/colors';
@use 'settings/settings';

.icon-on-hover {
  --icon-on-hover-size: 24px;

  width: var(--icon-on-hover-size);
  display: flex;
  justify-content: center;
  position: relative;
  color: colors.$color-grey-700;
  cursor: pointer;

  button {
    height: var(--icon-on-hover-size);
    width: var(--icon-on-hover-size);
  }

  &:hover:not(.icon-on-hover--disabled) {
    > .icon-on-hover__hover {
      opacity: 1;
    }
  }
}

.icon-on-hover__hover {
  transition: opacity 0.15s;
  opacity: 0;
  display: flex;
  pointer-events: none;
  position: absolute;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  background: colors.$color-grey-100;
  border-radius: settings.$border-radius;
}
</style>
